<template>
  <div class="pcg-tooltip">
    <div class="pcg-tooltip__bubble" :class="bubbleClasses">
      <div class="pcg-tooltip__bubble-arrow"></div>
      <div class="pcg-tooltip__bubble-content">
        <slot name="tooltip"></slot>
      </div>
    </div>
    <slot/>
  </div>
</template>

<script>
import {computed} from "@vue/reactivity";

export default {
  name: "Tooltip",
  props: {
    direction: {
      type: String,
      default: "left",
    }
  },
  setup(props) {
    const bubbleClasses = computed(() => {return ['pcg-tooltip__bubble--' + props.direction]});

    return  {
      bubbleClasses
    };
  }
}
</script>

<style scoped lang="scss">
.pcg-tooltip {
  position: relative;

  &__bubble {
    display: flex;
    transition: opacity .3s;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    height: 100%;
    align-items: center;
    $background-color: #2f2f2f;

    &--left {
      margin-right: 5px;
      right: 100%;
    }
    &--right {
      margin-left: 5px;
      left: 100%;
    }
    &--top {
      margin-bottom: 5px;
      bottom: 100%;
    }
    &--bottom {
      margin-top: 5px;
      top: 100%;
    }

    &-content {
      background-color: $background-color;
      color: white;
      padding: 3px 10px;
      border-radius: 3px;
      position: relative;
      white-space: nowrap;
    }
    &--left &-content {
      right: 7px;
    }
    &--right &-content {
      left: 7px;
    }
    &--top &-content {
      bottom: 7px;
    }
    &--bottom &-content {
      top: 7px;
    }

    &-arrow {
      width: 0;
      height: 0;
      position: absolute;
    }
    &--left &-arrow {
      border-top: 7px solid transparent;
      border-bottom: 7px solid transparent;
      border-left: 7px solid $background-color;
      right: 0;
    }
    &--right &-arrow {
      border-top: 7px solid transparent;
      border-bottom: 7px solid transparent;
      border-right: 7px solid $background-color;
      left: 0;
    }
    &--bottom &-arrow {
      border-right: 7px solid transparent;
      border-left: 7px solid transparent;
      border-bottom: 7px solid $background-color;
      top: 0;
    }
    &--top &-arrow {
      border-right: 7px solid transparent;
      border-left: 7px solid transparent;
      border-top: 7px solid $background-color;
      bottom: 0;
    }
  }

  &:hover &__bubble {
    opacity: 1;
  }
}
</style>